module.exports = __webpack_public_path__ + "img/kta.05de98b0.svg";